var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"discount-code-delete",attrs:{"data-test":"remove-discount-button"},on:{"click":_vm.removeDiscountCode}},[_c('img',{staticClass:"cart-action-icon",attrs:{"src":require("../../../../assets/img/delete-1.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }